import { Button, Space, Typography } from 'antd';
import React, { useState } from 'react';
import Stripe from 'stripe';
import ContentCard from '../../ContentCard';

import styles from './index.module.less';
import ConfirmModal from '../confirmModal';

interface IPlanItem {
  plan: Stripe.Plan;
  active?: boolean;
  handleChange: (id: string) => void;
  features: string[];
  buttonLabel?: string;
  loading?: boolean;
}

export const formatPlanData = (plan: Stripe.Plan) => {
  if (plan.amount) {
    const formattedAmount = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(plan.amount / 100);

    const interval = plan.interval?.slice(0, 2) === 'ye' ? 'yr' : plan.interval?.slice(0, 2);

    return `${formattedAmount}/${interval}`;
  }

  return `$0/${plan.interval?.slice(0, 2)}`;
};

const PlanItem = ({ plan, active, handleChange, buttonLabel, loading }: IPlanItem) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const toggleModal = () => setIsOpen(!isOpen);

  const label = plan.interval === 'year' ? 'Upgrade to the annual plan and save 20%?' : 'Downgrade to the monthly plan?'

  return (
    <ContentCard bordered padding={24} height="100%" background={active ? 'var(--color-border)' : 'transparent'}>
      <ConfirmModal isOpen={isOpen} handleChange={handleChange} id={plan.id} toggleModal={toggleModal} label={label} />
      <div className={styles.content}>
        <Space direction="vertical" size={12}>
          <Typography.Title level={3} className={styles.name}>
            {plan.nickname}
          </Typography.Title>
        </Space>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <Typography.Title>{formatPlanData(plan)}</Typography.Title>
          {plan.interval === 'year' && (
            <div
              style={{
                padding: '2px 10px',
                color: 'var(--color-blue)',
                border: '1px solid var(--color-blue)',
                borderRadius: 4,
              }}
            >
              20% OFF
            </div>
          )}
        </div>
        <div>
          <Button
            block={false}
            className="btn-default-dark-blue"
            type="default"
            size="large"
            onClick={() => toggleModal()}
            loading={active && loading}
            disabled={active || (!active && loading)}
          >
            {buttonLabel}
          </Button>
        </div>
      </div>
    </ContentCard>
  );
};

PlanItem.defaultProps = {
  active: false,
  buttonLabel: 'Upgrade',
  loading: false,
};

export default PlanItem;
